import { IconProps } from 'types/icon.type'

export const LinkedinIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Linkedin Logo</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0313 8.46615V10.2986C13.4048 9.70691 13.9258 9.2258 14.5415 8.90401C15.1572 8.58222 15.8458 8.43117 16.5375 8.46615C20.2563 8.46615 21 10.8376 21 13.8558V20H17.6V14.6104C17.6 13.209 17.3875 11.5921 15.3688 11.5921C13.35 11.5921 13.0313 12.9935 13.0313 14.3948V20H9.63125V8.46615H13.0313ZM7.4 5.55574C7.40842 5.82354 7.35522 6.08965 7.24463 6.33297C7.13403 6.57628 6.96908 6.79011 6.76285 6.95749C6.55662 7.12487 6.31478 7.2412 6.05652 7.29725C5.79826 7.35331 5.53068 7.34755 5.275 7.28043C5.04159 7.21022 4.82578 7.08998 4.64214 6.92783C4.45851 6.76568 4.31134 6.56541 4.2106 6.34056C4.10986 6.11572 4.0579 5.87155 4.05823 5.62456C4.05855 5.37758 4.11117 5.13355 4.2125 4.90898C4.32992 4.68706 4.49383 4.49393 4.6927 4.34315C4.89157 4.19238 5.12057 4.08762 5.36362 4.03625C5.60667 3.98488 5.85786 3.98814 6.09953 4.0458C6.34121 4.10347 6.5675 4.21413 6.7625 4.37002C7.08125 4.6934 7.29375 5.12457 7.29375 5.55574H7.4Z"
        fill="currentColor"
      />
      <path d="M7.4 8.46615H4V20H7.4V8.46615Z" fill="currentColor" />
    </svg>
  )
}
